import styled from "styled-components";
import { FaSearch } from 'react-icons/fa';

export const CrewStyle = styled.div`
    min-height: 100vh;
    width: 100%;
    background-color: #E5F8FA;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
`

export const WrapContent = styled.div`
    width: 75%;
    height: 80%;
    display: flex;
    flex-direction: column;
    /* background-color: red; */

    h1{
        margin: -10px 9px;
        padding: 0;
        color: #FF5742;
    }

    h2{
        color: black;
        font-size: 15px;
        margin-top: auto;
    }

    h3{
        color: #005CA9;
        font-size: 30px;
        margin-left: 9px;
        margin-top: 0;
    }
`

    interface NewRegisterCardProps {
    isExpanded?: boolean;
  }
  
  export const NewRegisterCard = styled.div<NewRegisterCardProps>`
    width: 100%;
    height: ${({ isExpanded }) => (isExpanded ? "220px" : "120px")};
    display: flex;
    flex-direction: column;
    border-radius: 20px;
    background-color: #ffffffcc;
    align-items: ${({ isExpanded }) => (isExpanded ? "flex-start" : "center")};
    justify-content: ${({ isExpanded }) => (isExpanded ? "flex-start" : "center")};
    padding: ${({ isExpanded }) => (isExpanded ? "16px" : "0")};
    box-shadow: 0px 2px 2px rgba(0, 0, 0, 0.5);
    transition: height 0.3s ease;

  h1 {
    color: black;
    font-weight: 500;
    font-size: 15px;
    padding-left: 12px;
    margin-bottom: 10px;
    align-self: flex-start;
  }

  h2 {
    color: black;
    font-size: 20px;
    margin-top: 10px;
  }
`;

export const IsExpandedColumn = styled.div`
    display: flex;
    flex-direction: column;
    width: 100%;
    align-items: flex-start;
    
`

export const SecondColumnExpanded = styled.div`
    display: flex;
    flex-direction: column;
    align-self: flex-start;
`

export const SearchContainer = styled.div<NewRegisterCardProps>`
    position: relative;
    width: 98%;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-bottom: ${({ isExpanded }) => (isExpanded ? "50px" : "0")};
`;

export const SearchIcon = styled(FaSearch)`
    position: absolute;
    right: 10px;
    top: 50%;
    transform: translateY(-50%);
    color: #005CA9;
    
    cursor: pointer;
`;

export const SearchBar = styled.input`
    position: relative;
    width: 100%;
    height: 40px;
    background-color: #F2F2F2;
    border: none;
    color: black;
    font-size: 18px;
    font-weight: 500;
    align-self: flex-start;
    padding-left: 9px;
    display: flex;
    justify-content: space-around;
    border-end-end-radius: 20px;
    border-end-start-radius: 20px;
    border-start-end-radius: 20px;
    border-start-start-radius: 20px;
    transition: all 0.3s ease;

    &:focus {
        border: 1px solid #5c8e;
        box-shadow: 0 0 8px rgba(92, 142, 200, 0.5); 
        outline: none; 
    }
`

export const ContractHistory = styled.div`
    margin-top: 20px;
    border-radius: 20px;
    width: 400px;
    height: 150px;
    display: flex;
    flex-direction: row;
    justify-content: space-evenly;
    align-items: center;
    background-color: #FFFFFFCC;
    cursor: pointer;
    box-shadow: 0px 2px 2px rgba(0, 0, 0, 0.5);
    position: relative;
    z-index: 10;

    h4{
        color: black;
        font-size: 25px;
        font-weight: 500;
        align-self: center;
        text-align: center;
    }
`

export const DocumentsAccess = styled.div`
    margin-top: 20px;
    border-radius: 20px;
    width: 400px;
    height: 150px;
    display: flex;
    flex-direction: row;
    justify-content: space-evenly;
    align-items: center;
    background-color: #FFFFFFCC;
    cursor: pointer;
    box-shadow: 0px 2px 2px rgba(0, 0, 0, 0.5);
    position: relative;
    z-index: 10;

    h4{
        color: black;
        font-size: 25px;
        font-weight: 500;
        align-self: center;
        text-align: center;
    }
`

export const IconsContainer = styled.div`
    display: flex;
    gap: 20px;
    flex-wrap: wrap;
    justify-content: center;
    align-items: center;
    margin-top: 20px;
    position: relative;
    z-index: 10;
`

export const StaticImage = styled.img`
    position: absolute;
    height: 100%; 
    top: -20px;
    pointer-events: none;
    right: 0;
    z-index: 0;
    transform: rotatex(180deg);
`

export const ConfirmButton = styled.button<NewRegisterCardProps>`
    background-color: #FF5641;
    display: ${({ isExpanded }) => (isExpanded ? "flex" : "none")};
    justify-content: center;
    align-items: center;
    width: 120px;
    padding: 8px;
    border: none;
    border-radius: 50px / 40px;
    color: #FFFFFF;
    font-size: 15px;
    font-weight: 600;
    cursor: pointer;
    position: absolute;
    bottom: -15px; 
    right: 70px; 
`

export const NewRegisterCardWrapper = styled.div`
  position: relative;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  align-self: self-start;
`;

export const LogoutButton = styled.button`
  position: absolute;
  top: 20px;
  right: 20px;
  background: none;
  border: none;
  color: red;
  font-size: 16px;
  cursor: pointer;
  display: flex;
  align-items: center;

  &:hover {
    color: #003f7d;
  }

  svg {
    margin-right: 5px;
  }
`;
